
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $3e4c8d654368a5f8$exports = {};
$3e4c8d654368a5f8$exports = JSON.parse("[{\"file\":\"geometrix.gbc\",\"name\":\"Geometrix\",\"genre\":\"Puzzle\"},{\"file\":\"legend-of-zelda.gb\",\"name\":\"Legend Of Zelda\",\"genre\":\"Game\"},{\"file\":\"snake.gb\",\"name\":\"Snake\",\"genre\":\"Arcade\"},{\"file\":\"tobu-tobu-girl.gb\",\"name\":\"Tobu Tobu Girl\",\"genre\":\"Platformer\"}]");


const $faeb2bdca75fd65c$export$b264eab3e2508b6 = 0;
const $faeb2bdca75fd65c$export$26a526c1bc0880ec = 1;
const $faeb2bdca75fd65c$export$79b0e864b8334eb8 = 2;
const $faeb2bdca75fd65c$export$b4d12237c45f302a = 3;
const $faeb2bdca75fd65c$export$5980fef2a1c75115 = 4;
const $faeb2bdca75fd65c$export$53341c93aaf417f1 = [
    'None',
    'LCD Grid',
    'CRT Scanlines',
    'CRT Curved'
];
const $faeb2bdca75fd65c$export$33507c450926adec = `
	attribute vec2 a_position;
	attribute vec2 a_texCoord;
	varying vec2 v_texCoord;
	void main() {
		gl_Position = vec4(a_position, 0.0, 1.0);
		v_texCoord = a_texCoord;
	}
`;
const $faeb2bdca75fd65c$export$96cc7ee7784ef477 = `
	precision mediump float;
	uniform sampler2D u_texture;
	varying vec2 v_texCoord;
	void main() {
		gl_FragColor = texture2D(u_texture, v_texCoord);
	}
`;
const $faeb2bdca75fd65c$export$171aeab6c40f2293 = `
	precision mediump float;
	uniform sampler2D u_texture;
	uniform vec2 u_resolution;
	varying vec2 v_texCoord;
	
	void main() {
		vec4 color = texture2D(u_texture, v_texCoord);
		vec2 pixelPos = v_texCoord * u_resolution;
		vec2 subPixel = fract(pixelPos * 3.0);
		
		float gridX = smoothstep(0.0, 0.1, subPixel.x) * smoothstep(1.0, 0.9, subPixel.x);
		float gridY = smoothstep(0.0, 0.1, subPixel.y) * smoothstep(1.0, 0.9, subPixel.y);
		float grid = gridX * gridY;
		
		vec3 subpixelMask = vec3(1.0);
		float subX = fract(pixelPos.x * 3.0);
		if (subX < 0.33) {
			subpixelMask = vec3(1.1, 0.9, 0.9);
		} else if (subX < 0.66) {
			subpixelMask = vec3(0.9, 1.1, 0.9);
		} else {
			subpixelMask = vec3(0.9, 0.9, 1.1);
		}
		
		vec3 finalColor = color.rgb * grid * 0.85 + color.rgb * 0.15;
		finalColor *= subpixelMask;
		
		gl_FragColor = vec4(finalColor, 1.0);
	}
`;
const $faeb2bdca75fd65c$export$62de1c56892f28db = `
	precision mediump float;
	uniform sampler2D u_texture;
	uniform vec2 u_resolution;
	uniform float u_time;
	varying vec2 v_texCoord;
	
	void main() {
		vec2 uv = v_texCoord;
		vec4 color = texture2D(u_texture, uv);
		
		float scanline = sin(uv.y * u_resolution.y * 3.14159) * 0.5 + 0.5;
		scanline = pow(scanline, 0.3) * 0.3 + 0.7;
		
		vec2 pixelSize = 1.0 / u_resolution;
		vec4 glow = texture2D(u_texture, uv + vec2(pixelSize.x, 0.0)) * 0.25;
		glow += texture2D(u_texture, uv - vec2(pixelSize.x, 0.0)) * 0.25;
		glow += color * 0.5;
		
		vec3 finalColor = mix(color.rgb, glow.rgb, 0.2);
		finalColor *= scanline;
		
		vec2 vignetteUV = uv * (1.0 - uv.yx);
		float vignette = vignetteUV.x * vignetteUV.y * 15.0;
		vignette = pow(vignette, 0.15);
		finalColor *= vignette;
		
		finalColor *= 1.15;
		
		gl_FragColor = vec4(finalColor, 1.0);
	}
`;
const $faeb2bdca75fd65c$export$dde07d74d116cbfb = `
	precision mediump float;
	uniform sampler2D u_texture;
	uniform vec2 u_resolution;
	uniform float u_time;
	varying vec2 v_texCoord;
	
	vec2 curveUV(vec2 uv) {
		uv = uv * 2.0 - 1.0;
		vec2 offset = abs(uv.yx) / vec2(6.0, 4.0);
		uv = uv + uv * offset * offset;
		uv = uv * 0.5 + 0.5;
		return uv;
	}
	
	void main() {
		vec2 uv = curveUV(v_texCoord);
		
		if (uv.x < 0.0 || uv.x > 1.0 || uv.y < 0.0 || uv.y > 1.0) {
			gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0);
			return;
		}
		
		vec4 color = texture2D(u_texture, uv);
		
		float aberration = length(v_texCoord - 0.5) * 0.01;
		float r = texture2D(u_texture, uv + vec2(aberration, 0.0)).r;
		float b = texture2D(u_texture, uv - vec2(aberration, 0.0)).b;
		color.r = r;
		color.b = b;
		
		float scanline = sin(uv.y * u_resolution.y * 3.14159) * 0.5 + 0.5;
		scanline = pow(scanline, 0.25) * 0.25 + 0.75;
		
		float pixelLine = sin(uv.x * u_resolution.x * 3.14159) * 0.5 + 0.5;
		pixelLine = pow(pixelLine, 0.5) * 0.1 + 0.9;
		
		vec3 finalColor = color.rgb * scanline * pixelLine;
		
		vec2 vignetteUV = uv * (1.0 - uv.yx);
		float vignette = vignetteUV.x * vignetteUV.y * 20.0;
		vignette = pow(vignette, 0.2);
		finalColor *= vignette;
		
		finalColor += color.rgb * 0.05;
		finalColor *= 1.2;
		
		gl_FragColor = vec4(finalColor, 1.0);
	}
`;
const $faeb2bdca75fd65c$export$341f244c92a49933 = [
    $faeb2bdca75fd65c$export$96cc7ee7784ef477,
    $faeb2bdca75fd65c$export$171aeab6c40f2293,
    $faeb2bdca75fd65c$export$62de1c56892f28db,
    $faeb2bdca75fd65c$export$dde07d74d116cbfb
];



const $222a0758e3193716$var$FB_SIZE = 23040;
let $222a0758e3193716$var$canvas = null;
let $222a0758e3193716$var$gl = null;
let $222a0758e3193716$var$ctx = null;
let $222a0758e3193716$var$glProgram = null;
let $222a0758e3193716$var$glTexture = null;
let $222a0758e3193716$var$textureData = null;
let $222a0758e3193716$var$cachedImageData = null;
let $222a0758e3193716$var$useWebGL = true;
let $222a0758e3193716$var$currentShader = (0, $faeb2bdca75fd65c$export$b264eab3e2508b6);
let $222a0758e3193716$var$uResolutionLoc = null;
let $222a0758e3193716$var$uTimeLoc = null;
let $222a0758e3193716$var$shaderStartTime = 0;
function $222a0758e3193716$export$fd40ab37176f343d() {
    return {
        canvas: $222a0758e3193716$var$canvas,
        gl: $222a0758e3193716$var$gl,
        ctx: $222a0758e3193716$var$ctx,
        glProgram: $222a0758e3193716$var$glProgram,
        glTexture: $222a0758e3193716$var$glTexture,
        textureData: $222a0758e3193716$var$textureData,
        cachedImageData: $222a0758e3193716$var$cachedImageData,
        useWebGL: $222a0758e3193716$var$useWebGL,
        currentShader: $222a0758e3193716$var$currentShader
    };
}
function $222a0758e3193716$export$79dccbf5b7f2d5b7(canvasElement) {
    $222a0758e3193716$var$canvas = canvasElement;
}
function $222a0758e3193716$export$40411e29a729bb7f() {
    return $222a0758e3193716$var$currentShader;
}
function $222a0758e3193716$export$242abfd0fe881094() {
    if (!$222a0758e3193716$var$canvas) $222a0758e3193716$var$canvas = document.getElementById('screen');
    $222a0758e3193716$var$gl = $222a0758e3193716$var$canvas.getContext('webgl', {
        antialias: false,
        alpha: false
    });
    if (!$222a0758e3193716$var$gl) {
        $222a0758e3193716$var$useWebGL = false;
        $222a0758e3193716$export$9b85c845a1e4be64();
        return false;
    }
    const savedShader = localStorage.getItem('gbemu-shader');
    if (savedShader !== null) {
        $222a0758e3193716$var$currentShader = parseInt(savedShader, 10);
        if (isNaN($222a0758e3193716$var$currentShader) || $222a0758e3193716$var$currentShader < 0 || $222a0758e3193716$var$currentShader >= (0, $faeb2bdca75fd65c$export$5980fef2a1c75115)) $222a0758e3193716$var$currentShader = (0, $faeb2bdca75fd65c$export$b264eab3e2508b6);
    }
    $222a0758e3193716$export$18094e0d8d1bebc1();
    const positions = new Float32Array([
        -1,
        -1,
        0,
        1,
        1,
        -1,
        1,
        1,
        -1,
        1,
        0,
        0,
        1,
        1,
        1,
        0
    ]);
    const buffer = $222a0758e3193716$var$gl.createBuffer();
    $222a0758e3193716$var$gl.bindBuffer($222a0758e3193716$var$gl.ARRAY_BUFFER, buffer);
    $222a0758e3193716$var$gl.bufferData($222a0758e3193716$var$gl.ARRAY_BUFFER, positions, $222a0758e3193716$var$gl.STATIC_DRAW);
    $222a0758e3193716$export$ad93d926f75e45b7();
    $222a0758e3193716$var$glTexture = $222a0758e3193716$var$gl.createTexture();
    $222a0758e3193716$var$gl.bindTexture($222a0758e3193716$var$gl.TEXTURE_2D, $222a0758e3193716$var$glTexture);
    $222a0758e3193716$var$gl.texParameteri($222a0758e3193716$var$gl.TEXTURE_2D, $222a0758e3193716$var$gl.TEXTURE_MIN_FILTER, $222a0758e3193716$var$gl.NEAREST);
    $222a0758e3193716$var$gl.texParameteri($222a0758e3193716$var$gl.TEXTURE_2D, $222a0758e3193716$var$gl.TEXTURE_MAG_FILTER, $222a0758e3193716$var$gl.NEAREST);
    $222a0758e3193716$var$gl.texParameteri($222a0758e3193716$var$gl.TEXTURE_2D, $222a0758e3193716$var$gl.TEXTURE_WRAP_S, $222a0758e3193716$var$gl.CLAMP_TO_EDGE);
    $222a0758e3193716$var$gl.texParameteri($222a0758e3193716$var$gl.TEXTURE_2D, $222a0758e3193716$var$gl.TEXTURE_WRAP_T, $222a0758e3193716$var$gl.CLAMP_TO_EDGE);
    $222a0758e3193716$var$textureData = new Uint8Array(92160);
    for(let i = 0; i < 23040; i++){
        $222a0758e3193716$var$textureData[i * 4] = 0x0f;
        $222a0758e3193716$var$textureData[i * 4 + 1] = 0x38;
        $222a0758e3193716$var$textureData[i * 4 + 2] = 0x0f;
        $222a0758e3193716$var$textureData[i * 4 + 3] = 255;
    }
    $222a0758e3193716$var$gl.texImage2D($222a0758e3193716$var$gl.TEXTURE_2D, 0, $222a0758e3193716$var$gl.RGBA, 160, 144, 0, $222a0758e3193716$var$gl.RGBA, $222a0758e3193716$var$gl.UNSIGNED_BYTE, $222a0758e3193716$var$textureData);
    $222a0758e3193716$var$gl.viewport(0, 0, $222a0758e3193716$var$canvas.width, $222a0758e3193716$var$canvas.height);
    $222a0758e3193716$export$d4e9b48aa9caf822();
    $222a0758e3193716$var$gl.drawArrays($222a0758e3193716$var$gl.TRIANGLE_STRIP, 0, 4);
    $222a0758e3193716$var$shaderStartTime = performance.now();
    return true;
}
function $222a0758e3193716$export$18094e0d8d1bebc1() {
    if (!$222a0758e3193716$var$gl) return;
    const vertexShader = $222a0758e3193716$var$gl.createShader($222a0758e3193716$var$gl.VERTEX_SHADER);
    $222a0758e3193716$var$gl.shaderSource(vertexShader, (0, $faeb2bdca75fd65c$export$33507c450926adec));
    $222a0758e3193716$var$gl.compileShader(vertexShader);
    if (!$222a0758e3193716$var$gl.getShaderParameter(vertexShader, $222a0758e3193716$var$gl.COMPILE_STATUS)) return;
    const fragmentShader = $222a0758e3193716$var$gl.createShader($222a0758e3193716$var$gl.FRAGMENT_SHADER);
    $222a0758e3193716$var$gl.shaderSource(fragmentShader, (0, $faeb2bdca75fd65c$export$341f244c92a49933)[$222a0758e3193716$var$currentShader]);
    $222a0758e3193716$var$gl.compileShader(fragmentShader);
    if (!$222a0758e3193716$var$gl.getShaderParameter(fragmentShader, $222a0758e3193716$var$gl.COMPILE_STATUS)) return;
    if ($222a0758e3193716$var$glProgram) $222a0758e3193716$var$gl.deleteProgram($222a0758e3193716$var$glProgram);
    $222a0758e3193716$var$glProgram = $222a0758e3193716$var$gl.createProgram();
    $222a0758e3193716$var$gl.attachShader($222a0758e3193716$var$glProgram, vertexShader);
    $222a0758e3193716$var$gl.attachShader($222a0758e3193716$var$glProgram, fragmentShader);
    $222a0758e3193716$var$gl.linkProgram($222a0758e3193716$var$glProgram);
    if (!$222a0758e3193716$var$gl.getProgramParameter($222a0758e3193716$var$glProgram, $222a0758e3193716$var$gl.LINK_STATUS)) return;
    $222a0758e3193716$var$gl.useProgram($222a0758e3193716$var$glProgram);
    $222a0758e3193716$var$uResolutionLoc = $222a0758e3193716$var$gl.getUniformLocation($222a0758e3193716$var$glProgram, 'u_resolution');
    $222a0758e3193716$var$uTimeLoc = $222a0758e3193716$var$gl.getUniformLocation($222a0758e3193716$var$glProgram, 'u_time');
    $222a0758e3193716$var$gl.deleteShader(vertexShader);
    $222a0758e3193716$var$gl.deleteShader(fragmentShader);
}
function $222a0758e3193716$export$ad93d926f75e45b7() {
    if (!$222a0758e3193716$var$gl || !$222a0758e3193716$var$glProgram) return;
    const positionLoc = $222a0758e3193716$var$gl.getAttribLocation($222a0758e3193716$var$glProgram, 'a_position');
    const texCoordLoc = $222a0758e3193716$var$gl.getAttribLocation($222a0758e3193716$var$glProgram, 'a_texCoord');
    $222a0758e3193716$var$gl.enableVertexAttribArray(positionLoc);
    $222a0758e3193716$var$gl.vertexAttribPointer(positionLoc, 2, $222a0758e3193716$var$gl.FLOAT, false, 16, 0);
    $222a0758e3193716$var$gl.enableVertexAttribArray(texCoordLoc);
    $222a0758e3193716$var$gl.vertexAttribPointer(texCoordLoc, 2, $222a0758e3193716$var$gl.FLOAT, false, 16, 8);
}
function $222a0758e3193716$export$d4e9b48aa9caf822() {
    if (!$222a0758e3193716$var$gl || !$222a0758e3193716$var$glProgram) return;
    if ($222a0758e3193716$var$uResolutionLoc) $222a0758e3193716$var$gl.uniform2f($222a0758e3193716$var$uResolutionLoc, 160.0, 144.0);
    if ($222a0758e3193716$var$uTimeLoc) {
        const time = (performance.now() - $222a0758e3193716$var$shaderStartTime) / 1000.0;
        $222a0758e3193716$var$gl.uniform1f($222a0758e3193716$var$uTimeLoc, time);
    }
}
function $222a0758e3193716$export$b9ebdbded0abb91d(worker = null, useOffscreenCanvas = false) {
    $222a0758e3193716$var$currentShader = ($222a0758e3193716$var$currentShader + 1) % (0, $faeb2bdca75fd65c$export$5980fef2a1c75115);
    localStorage.setItem('gbemu-shader', $222a0758e3193716$var$currentShader.toString());
    if ($222a0758e3193716$var$useWebGL && $222a0758e3193716$var$gl) {
        $222a0758e3193716$export$18094e0d8d1bebc1();
        $222a0758e3193716$export$ad93d926f75e45b7();
        $222a0758e3193716$export$d4e9b48aa9caf822();
        $222a0758e3193716$var$gl.bindTexture($222a0758e3193716$var$gl.TEXTURE_2D, $222a0758e3193716$var$glTexture);
    }
    if (useOffscreenCanvas && worker) worker.postMessage({
        type: 'set-shader',
        data: {
            shader: $222a0758e3193716$var$currentShader
        }
    });
    const shaderBtn = document.getElementById('shader-btn');
    if (shaderBtn) shaderBtn.title = `Shader: ${(0, $faeb2bdca75fd65c$export$53341c93aaf417f1)[$222a0758e3193716$var$currentShader]}`;
    return (0, $faeb2bdca75fd65c$export$53341c93aaf417f1)[$222a0758e3193716$var$currentShader];
}
function $222a0758e3193716$export$9b85c845a1e4be64() {
    if (!$222a0758e3193716$var$canvas) $222a0758e3193716$var$canvas = document.getElementById('screen');
    $222a0758e3193716$var$ctx = $222a0758e3193716$var$canvas.getContext('2d');
    $222a0758e3193716$var$ctx.imageSmoothingEnabled = false;
    $222a0758e3193716$var$ctx.fillStyle = '#0f380f';
    $222a0758e3193716$var$ctx.fillRect(0, 0, $222a0758e3193716$var$canvas.width, $222a0758e3193716$var$canvas.height);
    $222a0758e3193716$var$useWebGL = false;
}
function $222a0758e3193716$export$803abbb750d3129a(sharedFramebuffer, offset) {
    if (!$222a0758e3193716$var$gl || !$222a0758e3193716$var$textureData) return;
    for(let i = 0, j = 0; i < $222a0758e3193716$var$FB_SIZE; i++, j += 4){
        const color = sharedFramebuffer[offset + i];
        $222a0758e3193716$var$textureData[j] = color >> 16 & 0xff;
        $222a0758e3193716$var$textureData[j + 1] = color >> 8 & 0xff;
        $222a0758e3193716$var$textureData[j + 2] = color & 0xff;
        $222a0758e3193716$var$textureData[j + 3] = 255;
    }
    $222a0758e3193716$var$gl.texSubImage2D($222a0758e3193716$var$gl.TEXTURE_2D, 0, 0, 0, 160, 144, $222a0758e3193716$var$gl.RGBA, $222a0758e3193716$var$gl.UNSIGNED_BYTE, $222a0758e3193716$var$textureData);
    $222a0758e3193716$export$d4e9b48aa9caf822();
    $222a0758e3193716$var$gl.drawArrays($222a0758e3193716$var$gl.TRIANGLE_STRIP, 0, 4);
}
function $222a0758e3193716$export$2365c226159033f2(sharedFramebuffer, offset) {
    if (!$222a0758e3193716$var$ctx) return;
    if (!$222a0758e3193716$var$cachedImageData) $222a0758e3193716$var$cachedImageData = $222a0758e3193716$var$ctx.createImageData(160, 144);
    const data = $222a0758e3193716$var$cachedImageData.data;
    for(let i = 0, j = 0; i < $222a0758e3193716$var$FB_SIZE; i++, j += 4){
        const color = sharedFramebuffer[offset + i];
        data[j] = color >> 16 & 0xff;
        data[j + 1] = color >> 8 & 0xff;
        data[j + 2] = color & 0xff;
        data[j + 3] = 255;
    }
    $222a0758e3193716$var$ctx.putImageData($222a0758e3193716$var$cachedImageData, 0, 0);
}
function $222a0758e3193716$export$9a0e476cab1d82dd(fb) {
    if (!fb) return;
    if ($222a0758e3193716$var$useWebGL && $222a0758e3193716$var$gl) {
        for(let i = 0, j = 0; i < $222a0758e3193716$var$FB_SIZE; i++, j += 4){
            const color = fb[i];
            $222a0758e3193716$var$textureData[j] = color >> 16 & 0xff;
            $222a0758e3193716$var$textureData[j + 1] = color >> 8 & 0xff;
            $222a0758e3193716$var$textureData[j + 2] = color & 0xff;
            $222a0758e3193716$var$textureData[j + 3] = 255;
        }
        $222a0758e3193716$var$gl.texSubImage2D($222a0758e3193716$var$gl.TEXTURE_2D, 0, 0, 0, 160, 144, $222a0758e3193716$var$gl.RGBA, $222a0758e3193716$var$gl.UNSIGNED_BYTE, $222a0758e3193716$var$textureData);
        $222a0758e3193716$export$d4e9b48aa9caf822();
        $222a0758e3193716$var$gl.drawArrays($222a0758e3193716$var$gl.TRIANGLE_STRIP, 0, 4);
    } else if ($222a0758e3193716$var$ctx) {
        if (!$222a0758e3193716$var$cachedImageData) $222a0758e3193716$var$cachedImageData = $222a0758e3193716$var$ctx.createImageData(160, 144);
        const data = $222a0758e3193716$var$cachedImageData.data;
        for(let i = 0, j = 0; i < $222a0758e3193716$var$FB_SIZE; i++, j += 4){
            const color = fb[i];
            data[j] = color >> 16 & 0xff;
            data[j + 1] = color >> 8 & 0xff;
            data[j + 2] = color & 0xff;
            data[j + 3] = 255;
        }
        $222a0758e3193716$var$ctx.putImageData($222a0758e3193716$var$cachedImageData, 0, 0);
    }
}
function $222a0758e3193716$export$e00558f8b95fb567() {
    return $222a0758e3193716$var$useWebGL && $222a0758e3193716$var$gl !== null;
}
function $222a0758e3193716$export$14c2e5f633eb13e7() {
    return $222a0758e3193716$var$gl;
}
function $222a0758e3193716$export$638583901de7987d() {
    return $222a0758e3193716$var$ctx;
}


const $762562ac9bfcda93$var$AUDIO_BUFFER_SIZE = 16384;
const $762562ac9bfcda93$var$CTRL_AUDIO_WRITE_POS = 2;
let $762562ac9bfcda93$var$audioContext = null;
let $762562ac9bfcda93$var$audioWorkletNode = null;
let $762562ac9bfcda93$var$scriptProcessorNode = null;
let $762562ac9bfcda93$var$audioEnabled = false;
let $762562ac9bfcda93$var$audioReadPos = 0;
let $762562ac9bfcda93$var$isMuted = false;
let $762562ac9bfcda93$var$menuAudioContext = null;
let $762562ac9bfcda93$var$speakerElement = null;
function $762562ac9bfcda93$export$9aae99d5b562ef5c(element) {
    $762562ac9bfcda93$var$speakerElement = element;
}
function $762562ac9bfcda93$export$81b32540e2005e6() {
    return $762562ac9bfcda93$var$audioEnabled;
}
function $762562ac9bfcda93$export$b7d4540d9e78914c() {
    return $762562ac9bfcda93$var$isMuted;
}
function $762562ac9bfcda93$export$c818a982d8c74a3a() {
    return $762562ac9bfcda93$var$audioWorkletNode;
}
async function $762562ac9bfcda93$export$1f2069563ea460ea(sharedAudioSAB, sharedControlSAB) {
    if ($762562ac9bfcda93$var$audioContext) return;
    const sharedAudio = new Float32Array(sharedAudioSAB);
    const sharedControl = new Int32Array(sharedControlSAB);
    try {
        $762562ac9bfcda93$var$audioContext = new (window.AudioContext || window.webkitAudioContext)({
            sampleRate: 44100,
            latencyHint: 'interactive'
        });
        if ($762562ac9bfcda93$var$audioContext.audioWorklet) try {
            const workletCode = `
					class GBAudioProcessor extends AudioWorkletProcessor {
						constructor(options) {
							super();
							this.sharedAudio = null;
							this.sharedControl = null;
							this.readPos = 0;
							this.bufferSize = 16384;
							this.ctrlAudioWritePos = 2;
							this.lastLeft = 0;
							this.lastRight = 0;
							
							this.port.onmessage = (e) => {
								if (e.data.type === 'set-buffers') {
									this.sharedAudio = new Float32Array(e.data.audio);
									this.sharedControl = new Int32Array(e.data.control);
									this.readPos = 0;
									this.lastLeft = 0;
									this.lastRight = 0;
								} else if (e.data.type === 'reset') {
									this.readPos = 0;
									this.lastLeft = 0;
									this.lastRight = 0;
								}
							};
						}
						
						process(inputs, outputs, parameters) {
							if (!this.sharedAudio || !this.sharedControl) return true;
							
							const output = outputs[0];
							const left = output[0];
							const right = output[1] || left;
							const writePos = Atomics.load(this.sharedControl, this.ctrlAudioWritePos);
							
							for (let i = 0; i < left.length; i++) {
								if (this.readPos !== writePos) {
									this.lastLeft = this.sharedAudio[this.readPos];
									left[i] = this.lastLeft;
									this.readPos = (this.readPos + 1) % this.bufferSize;
								} else {
									this.lastLeft *= 0.95;
									left[i] = this.lastLeft;
								}
								if (this.readPos !== writePos) {
									this.lastRight = this.sharedAudio[this.readPos];
									right[i] = this.lastRight;
									this.readPos = (this.readPos + 1) % this.bufferSize;
								} else {
									this.lastRight *= 0.95;
									right[i] = this.lastRight;
								}
							}
							return true;
						}
					}
					registerProcessor('gb-audio-processor', GBAudioProcessor);
				`;
            const blob = new Blob([
                workletCode
            ], {
                type: 'application/javascript'
            });
            const url = URL.createObjectURL(blob);
            await $762562ac9bfcda93$var$audioContext.audioWorklet.addModule(url);
            URL.revokeObjectURL(url);
            $762562ac9bfcda93$var$audioWorkletNode = new AudioWorkletNode($762562ac9bfcda93$var$audioContext, 'gb-audio-processor');
            $762562ac9bfcda93$var$audioWorkletNode.port.postMessage({
                type: 'set-buffers',
                audio: sharedAudioSAB,
                control: sharedControlSAB
            });
            $762562ac9bfcda93$var$audioWorkletNode.connect($762562ac9bfcda93$var$audioContext.destination);
            $762562ac9bfcda93$var$audioEnabled = true;
            return;
        } catch  {}
        const bufferSize = 2048;
        $762562ac9bfcda93$var$scriptProcessorNode = $762562ac9bfcda93$var$audioContext.createScriptProcessor(bufferSize, 0, 2);
        $762562ac9bfcda93$var$scriptProcessorNode.onaudioprocess = (event)=>{
            if (!sharedAudio || !sharedControl || !$762562ac9bfcda93$var$audioEnabled) {
                event.outputBuffer.getChannelData(0).fill(0);
                event.outputBuffer.getChannelData(1).fill(0);
                return;
            }
            const writePos = Atomics.load(sharedControl, $762562ac9bfcda93$var$CTRL_AUDIO_WRITE_POS);
            const leftChannel = event.outputBuffer.getChannelData(0);
            const rightChannel = event.outputBuffer.getChannelData(1);
            for(let i = 0; i < bufferSize; i++){
                if ($762562ac9bfcda93$var$audioReadPos !== writePos) {
                    leftChannel[i] = sharedAudio[$762562ac9bfcda93$var$audioReadPos];
                    $762562ac9bfcda93$var$audioReadPos = ($762562ac9bfcda93$var$audioReadPos + 1) % $762562ac9bfcda93$var$AUDIO_BUFFER_SIZE;
                } else leftChannel[i] = 0;
                if ($762562ac9bfcda93$var$audioReadPos !== writePos) {
                    rightChannel[i] = sharedAudio[$762562ac9bfcda93$var$audioReadPos];
                    $762562ac9bfcda93$var$audioReadPos = ($762562ac9bfcda93$var$audioReadPos + 1) % $762562ac9bfcda93$var$AUDIO_BUFFER_SIZE;
                } else rightChannel[i] = 0;
            }
        };
        $762562ac9bfcda93$var$scriptProcessorNode.connect($762562ac9bfcda93$var$audioContext.destination);
        $762562ac9bfcda93$var$audioEnabled = true;
    } catch  {}
}
async function $762562ac9bfcda93$export$53a2138e98dc7b75(getEmu) {
    if ($762562ac9bfcda93$var$audioContext) return;
    try {
        $762562ac9bfcda93$var$audioContext = new (window.AudioContext || window.webkitAudioContext)({
            sampleRate: 44100,
            latencyHint: 'interactive'
        });
        if ($762562ac9bfcda93$var$audioContext.audioWorklet) try {
            const workletCode = `
					class GBAudioProcessor extends AudioWorkletProcessor {
						constructor() {
							super();
							this.bufferSize = 16384;
							this.buffer = new Float32Array(this.bufferSize);
							this.writePos = 0;
							this.readPos = 0;
							this.port.onmessage = (e) => {
								const samples = e.data;
								for (let i = 0; i < samples.length; i++) {
									this.buffer[this.writePos] = samples[i];
									this.writePos = (this.writePos + 1) % this.bufferSize;
								}
							};
						}
						process(inputs, outputs, parameters) {
							const output = outputs[0];
							const left = output[0];
							const right = output[1] || left;
							
							for (let i = 0; i < left.length; i++) {
								if (this.readPos !== this.writePos) {
									left[i] = this.buffer[this.readPos];
									this.readPos = (this.readPos + 1) % this.bufferSize;
								} else {
									left[i] = 0;
								}
								if (this.readPos !== this.writePos) {
									right[i] = this.buffer[this.readPos];
									this.readPos = (this.readPos + 1) % this.bufferSize;
								} else {
									right[i] = 0;
								}
							}
							return true;
						}
					}
					registerProcessor('gb-audio-processor', GBAudioProcessor);
				`;
            const blob = new Blob([
                workletCode
            ], {
                type: 'application/javascript'
            });
            const url = URL.createObjectURL(blob);
            await $762562ac9bfcda93$var$audioContext.audioWorklet.addModule(url);
            URL.revokeObjectURL(url);
            $762562ac9bfcda93$var$audioWorkletNode = new AudioWorkletNode($762562ac9bfcda93$var$audioContext, 'gb-audio-processor');
            $762562ac9bfcda93$var$audioWorkletNode.connect($762562ac9bfcda93$var$audioContext.destination);
            $762562ac9bfcda93$var$audioEnabled = true;
            return;
        } catch  {}
        const bufferSize = 2048;
        $762562ac9bfcda93$var$scriptProcessorNode = $762562ac9bfcda93$var$audioContext.createScriptProcessor(bufferSize, 0, 2);
        $762562ac9bfcda93$var$scriptProcessorNode.onaudioprocess = (event)=>{
            const emu = getEmu();
            if (!emu || !$762562ac9bfcda93$var$audioEnabled) {
                event.outputBuffer.getChannelData(0).fill(0);
                event.outputBuffer.getChannelData(1).fill(0);
                return;
            }
            const sampleCount = emu.getAudioSamplesCount();
            const audioBuffer = emu.getAudioBuffer();
            const leftChannel = event.outputBuffer.getChannelData(0);
            const rightChannel = event.outputBuffer.getChannelData(1);
            const samplesToUse = Math.min(sampleCount, bufferSize);
            for(let i = 0; i < samplesToUse; i++){
                leftChannel[i] = audioBuffer[i * 2];
                rightChannel[i] = audioBuffer[i * 2 + 1];
            }
            for(let i = samplesToUse; i < bufferSize; i++)leftChannel[i] = rightChannel[i] = 0;
        };
        $762562ac9bfcda93$var$scriptProcessorNode.connect($762562ac9bfcda93$var$audioContext.destination);
        $762562ac9bfcda93$var$audioEnabled = true;
    } catch  {}
}
async function $762562ac9bfcda93$export$a953d208b731f95c() {
    if ($762562ac9bfcda93$var$audioContext && $762562ac9bfcda93$var$audioContext.state === 'suspended') await $762562ac9bfcda93$var$audioContext.resume();
}
function $762562ac9bfcda93$export$8405bec9dd664ae() {
    $762562ac9bfcda93$var$audioReadPos = 0;
    if ($762562ac9bfcda93$var$audioWorkletNode) $762562ac9bfcda93$var$audioWorkletNode.port.postMessage({
        type: 'reset'
    });
}
function $762562ac9bfcda93$export$8ed30069de84a7d6() {
    $762562ac9bfcda93$var$isMuted = !$762562ac9bfcda93$var$isMuted;
    $762562ac9bfcda93$var$audioEnabled = !$762562ac9bfcda93$var$isMuted;
    if ($762562ac9bfcda93$var$speakerElement) $762562ac9bfcda93$var$speakerElement.classList.toggle('muted', $762562ac9bfcda93$var$isMuted);
}
function $762562ac9bfcda93$export$79bf80967493f6c1(emu) {
    if (!$762562ac9bfcda93$var$audioEnabled || !$762562ac9bfcda93$var$audioWorkletNode || !emu) return;
    const sampleCount = emu.getAudioSamplesCount();
    if (sampleCount > 0) {
        const audioBuffer = emu.getAudioBuffer();
        const samples = new Float32Array(sampleCount * 2);
        for(let i = 0; i < sampleCount * 2; i++)samples[i] = audioBuffer[i];
        $762562ac9bfcda93$var$audioWorkletNode.port.postMessage(samples);
    }
}
function $762562ac9bfcda93$var$getMenuAudioContext() {
    if (!$762562ac9bfcda93$var$menuAudioContext) $762562ac9bfcda93$var$menuAudioContext = new (window.AudioContext || window.webkitAudioContext)();
    return $762562ac9bfcda93$var$menuAudioContext;
}
function $762562ac9bfcda93$export$eaeea53739669088() {
    if ($762562ac9bfcda93$var$isMuted) return;
    try {
        const ctx = $762562ac9bfcda93$var$getMenuAudioContext();
        if (ctx.state === 'suspended') ctx.resume();
        const oscillator = ctx.createOscillator();
        const gainNode = ctx.createGain();
        oscillator.type = 'square';
        oscillator.frequency.setValueAtTime(880, ctx.currentTime);
        gainNode.gain.setValueAtTime(0.15, ctx.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.05);
        oscillator.connect(gainNode);
        gainNode.connect(ctx.destination);
        oscillator.start(ctx.currentTime);
        oscillator.stop(ctx.currentTime + 0.05);
    } catch  {}
}
function $762562ac9bfcda93$export$19b9b4c652d89687() {
    if ($762562ac9bfcda93$var$isMuted) return;
    try {
        const ctx = $762562ac9bfcda93$var$getMenuAudioContext();
        if (ctx.state === 'suspended') ctx.resume();
        const osc1 = ctx.createOscillator();
        const gain1 = ctx.createGain();
        osc1.type = 'square';
        osc1.frequency.setValueAtTime(660, ctx.currentTime);
        gain1.gain.setValueAtTime(0.15, ctx.currentTime);
        gain1.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.06);
        osc1.connect(gain1);
        gain1.connect(ctx.destination);
        osc1.start(ctx.currentTime);
        osc1.stop(ctx.currentTime + 0.06);
        const osc2 = ctx.createOscillator();
        const gain2 = ctx.createGain();
        osc2.type = 'square';
        osc2.frequency.setValueAtTime(880, ctx.currentTime + 0.06);
        gain2.gain.setValueAtTime(0.01, ctx.currentTime);
        gain2.gain.setValueAtTime(0.15, ctx.currentTime + 0.06);
        gain2.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.12);
        osc2.connect(gain2);
        gain2.connect(ctx.destination);
        osc2.start(ctx.currentTime + 0.06);
        osc2.stop(ctx.currentTime + 0.12);
    } catch  {}
}
function $762562ac9bfcda93$export$bbf5b9923049cd28() {
    return {
        audioContext: $762562ac9bfcda93$var$audioContext ? 'initialized' : 'not initialized',
        state: $762562ac9bfcda93$var$audioContext?.state || 'N/A',
        sampleRate: $762562ac9bfcda93$var$audioContext?.sampleRate || 'N/A',
        audioEnabled: $762562ac9bfcda93$var$audioEnabled,
        isMuted: $762562ac9bfcda93$var$isMuted,
        audioWorklet: $762562ac9bfcda93$var$audioWorkletNode ? 'active' : 'not active',
        scriptProcessor: $762562ac9bfcda93$var$scriptProcessorNode ? 'active' : 'not active'
    };
}


let $ce1d4f3ed1344587$var$useWorkerMode = false;
let $ce1d4f3ed1344587$var$useOffscreenCanvas = false;
let $ce1d4f3ed1344587$var$worker = null;
let $ce1d4f3ed1344587$var$sharedFramebufferSAB = null;
let $ce1d4f3ed1344587$var$sharedAudioSAB = null;
let $ce1d4f3ed1344587$var$sharedControlSAB = null;
let $ce1d4f3ed1344587$var$sharedFramebuffer = null;
let $ce1d4f3ed1344587$var$sharedAudio = null;
let $ce1d4f3ed1344587$var$sharedControl = null;
let $ce1d4f3ed1344587$var$emu = null;
let $ce1d4f3ed1344587$var$offscreenCanvas = null;
const $ce1d4f3ed1344587$var$FB_SIZE = 23040;
const $ce1d4f3ed1344587$var$AUDIO_BUFFER_SIZE = 16384;
const $ce1d4f3ed1344587$var$CTRL_FRAME_READY = 1;
const $ce1d4f3ed1344587$var$CTRL_BUTTONS = 3;
const $ce1d4f3ed1344587$var$CTRL_COMMAND = 4;
const $ce1d4f3ed1344587$var$CMD_NONE = 0;
const $ce1d4f3ed1344587$var$CMD_RESET = 1;
const $ce1d4f3ed1344587$var$CMD_PAUSE = 2;
const $ce1d4f3ed1344587$var$CMD_RESUME = 3;
let $ce1d4f3ed1344587$var$canvas;
let $ce1d4f3ed1344587$var$running = false;
let $ce1d4f3ed1344587$var$lastRenderedBuffer = -1;
let $ce1d4f3ed1344587$var$animationId = null;
let $ce1d4f3ed1344587$var$fpsDisplay;
let $ce1d4f3ed1344587$var$statusDisplay;
let $ce1d4f3ed1344587$var$frameCount = 0;
let $ce1d4f3ed1344587$var$fpsUpdateTime = 0;
let $ce1d4f3ed1344587$var$selectedGameIndex = 0;
let $ce1d4f3ed1344587$var$gameItems = [];
let $ce1d4f3ed1344587$var$isMenuActive = true;
let $ce1d4f3ed1344587$var$overlay;
let $ce1d4f3ed1344587$var$loadBtn;
let $ce1d4f3ed1344587$var$resetBtn;
let $ce1d4f3ed1344587$var$fullscreenBtn;
let $ce1d4f3ed1344587$var$shaderBtn;
let $ce1d4f3ed1344587$var$romInput;
let $ce1d4f3ed1344587$var$powerLed;
let $ce1d4f3ed1344587$var$speaker;
let $ce1d4f3ed1344587$var$gameboy;
let $ce1d4f3ed1344587$var$backToMenuBtn;
const $ce1d4f3ed1344587$var$keyMap = {
    KeyZ: 0,
    KeyX: 1,
    Enter: 3,
    ShiftLeft: 2,
    ShiftRight: 2,
    ArrowRight: 4,
    ArrowLeft: 5,
    ArrowUp: 6,
    ArrowDown: 7
};
const $ce1d4f3ed1344587$var$keyMapFallback = {
    KeyZ: 'BUTTON_A',
    KeyX: 'BUTTON_B',
    Enter: 'BUTTON_START',
    ShiftLeft: 'BUTTON_SELECT',
    ShiftRight: 'BUTTON_SELECT',
    ArrowRight: 'BUTTON_RIGHT',
    ArrowLeft: 'BUTTON_LEFT',
    ArrowUp: 'BUTTON_UP',
    ArrowDown: 'BUTTON_DOWN'
};
let $ce1d4f3ed1344587$var$buttonState = 0;
function $ce1d4f3ed1344587$var$resetButtonState() {
    $ce1d4f3ed1344587$var$buttonState = 0;
    if ($ce1d4f3ed1344587$var$sharedControl) Atomics.store($ce1d4f3ed1344587$var$sharedControl, $ce1d4f3ed1344587$var$CTRL_BUTTONS, 0);
}
const $ce1d4f3ed1344587$var$screenButtonMap = {
    a: 0,
    b: 1,
    select: 2,
    start: 3,
    right: 4,
    left: 5,
    up: 6,
    down: 7
};
const $ce1d4f3ed1344587$var$screenButtonMapFallback = {
    a: 'BUTTON_A',
    b: 'BUTTON_B',
    select: 'BUTTON_SELECT',
    start: 'BUTTON_START',
    right: 'BUTTON_RIGHT',
    left: 'BUTTON_LEFT',
    up: 'BUTTON_UP',
    down: 'BUTTON_DOWN'
};
let $ce1d4f3ed1344587$var$currentShader = (0, $faeb2bdca75fd65c$export$b264eab3e2508b6);
function $ce1d4f3ed1344587$var$getRomUrl(filename) {
    const path = window.location.pathname;
    if (path.startsWith('/labs/gbemu')) return `/labs/gbemu/roms/${filename}`;
    return `./roms/${filename}`;
}
function $ce1d4f3ed1344587$var$isSharedArrayBufferAvailable() {
    try {
        new SharedArrayBuffer(1);
        return true;
    } catch (e) {
        return false;
    }
}
function $ce1d4f3ed1344587$var$isOffscreenCanvasAvailable() {
    try {
        if (typeof OffscreenCanvas === 'undefined') return false;
        const testCanvas = document.createElement('canvas');
        if (typeof testCanvas.transferControlToOffscreen !== 'function') return false;
        const offscreen = testCanvas.transferControlToOffscreen();
        const ctx = offscreen.getContext('webgl');
        return ctx !== null;
    } catch (e) {
        return false;
    }
}
function $ce1d4f3ed1344587$var$initSharedMemory() {
    $ce1d4f3ed1344587$var$sharedFramebufferSAB = new SharedArrayBuffer($ce1d4f3ed1344587$var$FB_SIZE * 8);
    $ce1d4f3ed1344587$var$sharedFramebuffer = new Uint32Array($ce1d4f3ed1344587$var$sharedFramebufferSAB);
    $ce1d4f3ed1344587$var$sharedAudioSAB = new SharedArrayBuffer($ce1d4f3ed1344587$var$AUDIO_BUFFER_SIZE * 4);
    $ce1d4f3ed1344587$var$sharedAudio = new Float32Array($ce1d4f3ed1344587$var$sharedAudioSAB);
    $ce1d4f3ed1344587$var$sharedControlSAB = new SharedArrayBuffer(32);
    $ce1d4f3ed1344587$var$sharedControl = new Int32Array($ce1d4f3ed1344587$var$sharedControlSAB);
}
function $ce1d4f3ed1344587$var$initWebGL() {
    $ce1d4f3ed1344587$var$canvas = document.getElementById('screen');
    $222a0758e3193716$export$79dccbf5b7f2d5b7($ce1d4f3ed1344587$var$canvas);
    const success = $222a0758e3193716$export$242abfd0fe881094();
    $ce1d4f3ed1344587$var$currentShader = $222a0758e3193716$export$40411e29a729bb7f();
    return success;
}
function $ce1d4f3ed1344587$var$cycleShader() {
    const shaderName = $222a0758e3193716$export$b9ebdbded0abb91d($ce1d4f3ed1344587$var$worker, $ce1d4f3ed1344587$var$useOffscreenCanvas);
    $ce1d4f3ed1344587$var$currentShader = $222a0758e3193716$export$40411e29a729bb7f();
    return shaderName;
}
function $ce1d4f3ed1344587$var$initCanvas2D() {
    $ce1d4f3ed1344587$var$canvas = document.getElementById('screen');
    $222a0758e3193716$export$79dccbf5b7f2d5b7($ce1d4f3ed1344587$var$canvas);
    $222a0758e3193716$export$9b85c845a1e4be64();
}
async function $ce1d4f3ed1344587$var$initAudioOffscreenMode() {
    return $762562ac9bfcda93$export$1f2069563ea460ea($ce1d4f3ed1344587$var$sharedAudioSAB, $ce1d4f3ed1344587$var$sharedControlSAB);
}
var $580cad83d1643c89$exports = {};
var $51c90d6534c5e34b$exports = {};
"use strict";
$51c90d6534c5e34b$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $580cad83d1643c89$var$url = new URL(import.meta.resolve("cuzVO"));
$580cad83d1643c89$exports = $51c90d6534c5e34b$exports($580cad83d1643c89$var$url.toString(), $580cad83d1643c89$var$url.origin, true);


function $ce1d4f3ed1344587$var$initWorkerOffscreen() {
    $ce1d4f3ed1344587$var$worker = new Worker($580cad83d1643c89$exports);
    $ce1d4f3ed1344587$var$worker.onmessage = $ce1d4f3ed1344587$var$handleWorkerMessageOffscreen;
    $ce1d4f3ed1344587$var$worker.onerror = ()=>{
        $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Worker error';
    };
    $ce1d4f3ed1344587$var$worker.postMessage({
        type: 'init'
    });
}
function $ce1d4f3ed1344587$var$handleWorkerMessageOffscreen(e) {
    const { type: type, ...data } = e.data;
    switch(type){
        case 'ready':
            $ce1d4f3ed1344587$var$canvas = document.getElementById('screen');
            $ce1d4f3ed1344587$var$offscreenCanvas = $ce1d4f3ed1344587$var$canvas.transferControlToOffscreen();
            $ce1d4f3ed1344587$var$worker.postMessage({
                type: 'set-offscreen-canvas',
                data: {
                    canvas: $ce1d4f3ed1344587$var$offscreenCanvas
                }
            }, [
                $ce1d4f3ed1344587$var$offscreenCanvas
            ]);
            break;
        case 'offscreen-ready':
            $ce1d4f3ed1344587$var$worker.postMessage({
                type: 'set-shared-memory',
                data: {
                    audio: $ce1d4f3ed1344587$var$sharedAudioSAB,
                    control: $ce1d4f3ed1344587$var$sharedControlSAB,
                    shader: $ce1d4f3ed1344587$var$currentShader
                }
            });
            break;
        case 'shared-memory-ready':
            $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Ready';
            break;
        case 'rom-loaded':
            $ce1d4f3ed1344587$var$resetBtn.disabled = false;
            $ce1d4f3ed1344587$var$powerLed.classList.add('on');
            $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Running';
            $ce1d4f3ed1344587$var$running = true;
            $ce1d4f3ed1344587$var$resetButtonState();
            $ce1d4f3ed1344587$var$initAudioOffscreenMode();
            $762562ac9bfcda93$export$8405bec9dd664ae();
            $762562ac9bfcda93$export$a953d208b731f95c();
            break;
        case 'fps':
            $ce1d4f3ed1344587$var$fpsDisplay.textContent = data.fps;
            break;
        case 'paused':
            $ce1d4f3ed1344587$var$running = false;
            $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Paused';
            break;
        case 'resumed':
            $ce1d4f3ed1344587$var$running = true;
            $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Running';
            break;
        case 'error':
            $ce1d4f3ed1344587$var$statusDisplay.textContent = data.message;
            break;
    }
}
function $ce1d4f3ed1344587$var$initSharedMemoryOffscreen() {
    $ce1d4f3ed1344587$var$sharedAudioSAB = new SharedArrayBuffer($ce1d4f3ed1344587$var$AUDIO_BUFFER_SIZE * 4);
    $ce1d4f3ed1344587$var$sharedAudio = new Float32Array($ce1d4f3ed1344587$var$sharedAudioSAB);
    $ce1d4f3ed1344587$var$sharedControlSAB = new SharedArrayBuffer(32);
    $ce1d4f3ed1344587$var$sharedControl = new Int32Array($ce1d4f3ed1344587$var$sharedControlSAB);
}
function $ce1d4f3ed1344587$var$loadROMOffscreen(arrayBuffer) {
    if (!$ce1d4f3ed1344587$var$worker) return;
    $ce1d4f3ed1344587$var$worker.postMessage({
        type: 'load-rom',
        data: {
            rom: arrayBuffer
        }
    });
}
function $ce1d4f3ed1344587$var$togglePauseOffscreen() {
    if (!$ce1d4f3ed1344587$var$sharedControl) return;
    Atomics.store($ce1d4f3ed1344587$var$sharedControl, $ce1d4f3ed1344587$var$CTRL_COMMAND, $ce1d4f3ed1344587$var$running ? $ce1d4f3ed1344587$var$CMD_PAUSE : $ce1d4f3ed1344587$var$CMD_RESUME);
}
function $ce1d4f3ed1344587$var$resetEmulationOffscreen() {
    if (!$ce1d4f3ed1344587$var$sharedControl) return;
    Atomics.store($ce1d4f3ed1344587$var$sharedControl, $ce1d4f3ed1344587$var$CTRL_COMMAND, $ce1d4f3ed1344587$var$CMD_RESET);
}
function $ce1d4f3ed1344587$var$handleKeyDownOffscreen(e) {
    if (e.code === 'KeyS') {
        e.preventDefault();
        $ce1d4f3ed1344587$var$showShaderNotification($ce1d4f3ed1344587$var$cycleShader());
        return;
    }
    const bit = $ce1d4f3ed1344587$var$keyMap[e.code];
    if (bit !== undefined) {
        e.preventDefault();
        // When menu is active, handle menu input and don't send to emulator
        if ($ce1d4f3ed1344587$var$isMenuActive) {
            $ce1d4f3ed1344587$var$handleMenuInput($ce1d4f3ed1344587$var$getActionFromKeyCode(e.code));
            return;
        }
        $ce1d4f3ed1344587$var$buttonState |= 1 << bit;
        if ($ce1d4f3ed1344587$var$sharedControl) Atomics.store($ce1d4f3ed1344587$var$sharedControl, $ce1d4f3ed1344587$var$CTRL_BUTTONS, $ce1d4f3ed1344587$var$buttonState);
    }
}
function $ce1d4f3ed1344587$var$handleKeyUpOffscreen(e) {
    const bit = $ce1d4f3ed1344587$var$keyMap[e.code];
    if (bit !== undefined) {
        e.preventDefault();
        // Don't update button state when menu is active
        if ($ce1d4f3ed1344587$var$isMenuActive) return;
        $ce1d4f3ed1344587$var$buttonState &= ~(1 << bit);
        if ($ce1d4f3ed1344587$var$sharedControl) Atomics.store($ce1d4f3ed1344587$var$sharedControl, $ce1d4f3ed1344587$var$CTRL_BUTTONS, $ce1d4f3ed1344587$var$buttonState);
    }
}
function $ce1d4f3ed1344587$var$getActionFromKeyCode(code) {
    const actionMap = {
        ArrowUp: 'up',
        ArrowDown: 'down',
        ArrowLeft: 'left',
        ArrowRight: 'right',
        KeyZ: 'a',
        KeyX: 'b',
        Enter: 'start',
        ShiftLeft: 'select',
        ShiftRight: 'select'
    };
    return actionMap[code] || null;
}
var $74199c0b668e2217$exports = {};

let $74199c0b668e2217$var$url = new URL(import.meta.resolve("a8oGD"));
$74199c0b668e2217$exports = $51c90d6534c5e34b$exports($74199c0b668e2217$var$url.toString(), $74199c0b668e2217$var$url.origin, true);


function $ce1d4f3ed1344587$var$initWorker() {
    $ce1d4f3ed1344587$var$worker = new Worker($74199c0b668e2217$exports);
    $ce1d4f3ed1344587$var$worker.onmessage = $ce1d4f3ed1344587$var$handleWorkerMessage;
    $ce1d4f3ed1344587$var$worker.onerror = (e)=>{
        $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Worker error';
    };
    $ce1d4f3ed1344587$var$worker.postMessage({
        type: 'init'
    });
}
function $ce1d4f3ed1344587$var$handleWorkerMessage(e) {
    const { type: type, ...data } = e.data;
    switch(type){
        case 'ready':
            $ce1d4f3ed1344587$var$worker.postMessage({
                type: 'set-shared-memory',
                data: {
                    framebuffer: $ce1d4f3ed1344587$var$sharedFramebufferSAB,
                    audio: $ce1d4f3ed1344587$var$sharedAudioSAB,
                    control: $ce1d4f3ed1344587$var$sharedControlSAB
                }
            });
            $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Ready';
            break;
        case 'shared-memory-ready':
            break;
        case 'rom-loaded':
            $ce1d4f3ed1344587$var$resetBtn.disabled = false;
            $ce1d4f3ed1344587$var$powerLed.classList.add('on');
            $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Running';
            $ce1d4f3ed1344587$var$running = true;
            $ce1d4f3ed1344587$var$resetButtonState();
            $762562ac9bfcda93$export$1f2069563ea460ea($ce1d4f3ed1344587$var$sharedAudioSAB, $ce1d4f3ed1344587$var$sharedControlSAB);
            $762562ac9bfcda93$export$8405bec9dd664ae();
            $762562ac9bfcda93$export$a953d208b731f95c();
            $ce1d4f3ed1344587$var$startRenderLoopWorker();
            break;
        case 'fps':
            $ce1d4f3ed1344587$var$fpsDisplay.textContent = data.fps;
            break;
        case 'paused':
            $ce1d4f3ed1344587$var$running = false;
            $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Paused';
            if ($ce1d4f3ed1344587$var$animationId) {
                cancelAnimationFrame($ce1d4f3ed1344587$var$animationId);
                $ce1d4f3ed1344587$var$animationId = null;
            }
            break;
        case 'resumed':
            $ce1d4f3ed1344587$var$running = true;
            $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Running';
            $ce1d4f3ed1344587$var$startRenderLoopWorker();
            break;
        case 'error':
            $ce1d4f3ed1344587$var$statusDisplay.textContent = data.message;
            break;
    }
}
function $ce1d4f3ed1344587$var$renderLoopWorker() {
    if (!$ce1d4f3ed1344587$var$running) return;
    const readyBuffer = Atomics.load($ce1d4f3ed1344587$var$sharedControl, $ce1d4f3ed1344587$var$CTRL_FRAME_READY);
    if (readyBuffer !== $ce1d4f3ed1344587$var$lastRenderedBuffer) {
        const offset = readyBuffer * $ce1d4f3ed1344587$var$FB_SIZE;
        if ($222a0758e3193716$export$e00558f8b95fb567()) $222a0758e3193716$export$803abbb750d3129a($ce1d4f3ed1344587$var$sharedFramebuffer, offset);
        else $222a0758e3193716$export$2365c226159033f2($ce1d4f3ed1344587$var$sharedFramebuffer, offset);
        $ce1d4f3ed1344587$var$lastRenderedBuffer = readyBuffer;
    }
    $ce1d4f3ed1344587$var$animationId = requestAnimationFrame($ce1d4f3ed1344587$var$renderLoopWorker);
}
function $ce1d4f3ed1344587$var$startRenderLoopWorker() {
    if (!$ce1d4f3ed1344587$var$animationId) {
        $ce1d4f3ed1344587$var$lastRenderedBuffer = -1;
        $ce1d4f3ed1344587$var$animationId = requestAnimationFrame($ce1d4f3ed1344587$var$renderLoopWorker);
    }
}
function $ce1d4f3ed1344587$var$loadROMWorker(arrayBuffer) {
    if (!$ce1d4f3ed1344587$var$worker) return;
    $ce1d4f3ed1344587$var$worker.postMessage({
        type: 'load-rom',
        data: {
            rom: arrayBuffer
        }
    });
}
function $ce1d4f3ed1344587$var$togglePauseWorker() {
    if (!$ce1d4f3ed1344587$var$sharedControl) return;
    Atomics.store($ce1d4f3ed1344587$var$sharedControl, $ce1d4f3ed1344587$var$CTRL_COMMAND, $ce1d4f3ed1344587$var$running ? $ce1d4f3ed1344587$var$CMD_PAUSE : $ce1d4f3ed1344587$var$CMD_RESUME);
}
function $ce1d4f3ed1344587$var$resetEmulationWorker() {
    if (!$ce1d4f3ed1344587$var$sharedControl) return;
    Atomics.store($ce1d4f3ed1344587$var$sharedControl, $ce1d4f3ed1344587$var$CTRL_COMMAND, $ce1d4f3ed1344587$var$CMD_RESET);
}
function $ce1d4f3ed1344587$var$handleKeyDownWorker(e) {
    if (e.code === 'KeyS') {
        e.preventDefault();
        $ce1d4f3ed1344587$var$showShaderNotification($ce1d4f3ed1344587$var$cycleShader());
        return;
    }
    const bit = $ce1d4f3ed1344587$var$keyMap[e.code];
    if (bit !== undefined) {
        e.preventDefault();
        // When menu is active, handle menu input and don't send to emulator
        if ($ce1d4f3ed1344587$var$isMenuActive) {
            $ce1d4f3ed1344587$var$handleMenuInput($ce1d4f3ed1344587$var$getActionFromKeyCode(e.code));
            return;
        }
        $ce1d4f3ed1344587$var$buttonState |= 1 << bit;
        if ($ce1d4f3ed1344587$var$sharedControl) Atomics.store($ce1d4f3ed1344587$var$sharedControl, $ce1d4f3ed1344587$var$CTRL_BUTTONS, $ce1d4f3ed1344587$var$buttonState);
    }
}
function $ce1d4f3ed1344587$var$handleKeyUpWorker(e) {
    const bit = $ce1d4f3ed1344587$var$keyMap[e.code];
    if (bit !== undefined) {
        e.preventDefault();
        // Don't update button state when menu is active
        if ($ce1d4f3ed1344587$var$isMenuActive) return;
        $ce1d4f3ed1344587$var$buttonState &= ~(1 << bit);
        if ($ce1d4f3ed1344587$var$sharedControl) Atomics.store($ce1d4f3ed1344587$var$sharedControl, $ce1d4f3ed1344587$var$CTRL_BUTTONS, $ce1d4f3ed1344587$var$buttonState);
    }
}
async function $ce1d4f3ed1344587$var$initEmulatorFallback() {
    try {
        $ce1d4f3ed1344587$var$emu = await createGBEmu();
        $ce1d4f3ed1344587$var$emu.init();
        $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Ready';
    } catch  {
        $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Failed to load';
    }
}
function $ce1d4f3ed1344587$var$emulationLoopFallback(timestamp) {
    if (!$ce1d4f3ed1344587$var$running) return;
    $ce1d4f3ed1344587$var$emu.runFrame();
    $222a0758e3193716$export$9a0e476cab1d82dd($ce1d4f3ed1344587$var$emu.getFramebuffer());
    $762562ac9bfcda93$export$79bf80967493f6c1($ce1d4f3ed1344587$var$emu);
    $ce1d4f3ed1344587$var$frameCount++;
    if (timestamp - $ce1d4f3ed1344587$var$fpsUpdateTime >= 1000) {
        $ce1d4f3ed1344587$var$fpsDisplay.textContent = $ce1d4f3ed1344587$var$frameCount;
        $ce1d4f3ed1344587$var$frameCount = 0;
        $ce1d4f3ed1344587$var$fpsUpdateTime = timestamp;
    }
    $ce1d4f3ed1344587$var$animationId = requestAnimationFrame($ce1d4f3ed1344587$var$emulationLoopFallback);
}
function $ce1d4f3ed1344587$var$loadROMFallback(arrayBuffer) {
    if (!$ce1d4f3ed1344587$var$emu) return false;
    const data = new Uint8Array(arrayBuffer);
    const ptr = $ce1d4f3ed1344587$var$emu.allocateROMBuffer(data.length);
    if (!ptr) {
        $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Memory error';
        $ce1d4f3ed1344587$var$showGameMenu();
        return false;
    }
    $ce1d4f3ed1344587$var$emu.HEAPU8.set(data, ptr);
    if ($ce1d4f3ed1344587$var$emu.loadROMFromBuffer(data.length)) {
        $ce1d4f3ed1344587$var$resetBtn.disabled = false;
        $ce1d4f3ed1344587$var$powerLed.classList.add('on');
        $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Running';
        $ce1d4f3ed1344587$var$resetButtonState();
        $762562ac9bfcda93$export$53a2138e98dc7b75(()=>$ce1d4f3ed1344587$var$emu);
        $ce1d4f3ed1344587$var$startEmulationFallback();
        return true;
    } else {
        $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Invalid ROM';
        $ce1d4f3ed1344587$var$showGameMenu();
        return false;
    }
}
function $ce1d4f3ed1344587$var$startEmulationFallback() {
    $ce1d4f3ed1344587$var$running = true;
    $ce1d4f3ed1344587$var$fpsUpdateTime = performance.now();
    $ce1d4f3ed1344587$var$frameCount = 0;
    $762562ac9bfcda93$export$a953d208b731f95c();
    $ce1d4f3ed1344587$var$animationId = requestAnimationFrame($ce1d4f3ed1344587$var$emulationLoopFallback);
}
function $ce1d4f3ed1344587$var$pauseEmulationFallback() {
    $ce1d4f3ed1344587$var$running = false;
    if ($ce1d4f3ed1344587$var$animationId) {
        cancelAnimationFrame($ce1d4f3ed1344587$var$animationId);
        $ce1d4f3ed1344587$var$animationId = null;
    }
    $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Paused';
}
function $ce1d4f3ed1344587$var$togglePauseFallback() {
    if ($ce1d4f3ed1344587$var$running) $ce1d4f3ed1344587$var$pauseEmulationFallback();
    else {
        $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Running';
        $ce1d4f3ed1344587$var$startEmulationFallback();
    }
}
function $ce1d4f3ed1344587$var$resetEmulationFallback() {
    if ($ce1d4f3ed1344587$var$emu) {
        $ce1d4f3ed1344587$var$emu.reset();
        if (!$ce1d4f3ed1344587$var$running) $ce1d4f3ed1344587$var$startEmulationFallback();
    }
}
function $ce1d4f3ed1344587$var$handleKeyDownFallback(e) {
    if (e.code === 'KeyS') {
        e.preventDefault();
        $ce1d4f3ed1344587$var$showShaderNotification($ce1d4f3ed1344587$var$cycleShader());
        return;
    }
    if ($ce1d4f3ed1344587$var$isMenuActive) {
        const bit = $ce1d4f3ed1344587$var$keyMap[e.code];
        if (bit !== undefined) {
            e.preventDefault();
            if (!$ce1d4f3ed1344587$var$handleMenuInput($ce1d4f3ed1344587$var$getActionFromKeyCode(e.code))) return;
        }
        return;
    }
    if (!$ce1d4f3ed1344587$var$emu || !$ce1d4f3ed1344587$var$running) return;
    const button = $ce1d4f3ed1344587$var$keyMapFallback[e.code];
    if (button) {
        e.preventDefault();
        $ce1d4f3ed1344587$var$emu.setButton($ce1d4f3ed1344587$var$emu[button], true);
    }
}
function $ce1d4f3ed1344587$var$handleKeyUpFallback(e) {
    // Don't update button state when menu is active
    if ($ce1d4f3ed1344587$var$isMenuActive) return;
    if (!$ce1d4f3ed1344587$var$emu) return;
    const button = $ce1d4f3ed1344587$var$keyMapFallback[e.code];
    if (button) {
        e.preventDefault();
        $ce1d4f3ed1344587$var$emu.setButton($ce1d4f3ed1344587$var$emu[button], false);
    }
}
function $ce1d4f3ed1344587$var$showShaderNotification(shaderName) {
    $ce1d4f3ed1344587$var$statusDisplay.textContent = shaderName;
    setTimeout(()=>{
        $ce1d4f3ed1344587$var$statusDisplay.textContent = $ce1d4f3ed1344587$var$running ? 'Running' : 'Ready';
    }, 1000);
}
function $ce1d4f3ed1344587$var$toggleFullscreen() {
    if (!document.fullscreenElement) $ce1d4f3ed1344587$var$gameboy.requestFullscreen().catch(()=>{});
    else document.exitFullscreen();
}
function $ce1d4f3ed1344587$var$handleDragOver(e) {
    e.preventDefault();
    $ce1d4f3ed1344587$var$overlay.classList.add('dragover');
}
function $ce1d4f3ed1344587$var$handleDragLeave(e) {
    e.preventDefault();
    $ce1d4f3ed1344587$var$overlay.classList.remove('dragover');
}
function $ce1d4f3ed1344587$var$handleDrop(e) {
    e.preventDefault();
    $ce1d4f3ed1344587$var$overlay.classList.remove('dragover');
    $ce1d4f3ed1344587$var$loadROMFromFile(e.dataTransfer.files[0]);
}
function $ce1d4f3ed1344587$var$handleFileSelect(e) {
    $ce1d4f3ed1344587$var$loadROMFromFile(e.target.files[0]);
    e.target.value = '';
}
function $ce1d4f3ed1344587$var$handleScreenTap(e) {
    if (!$ce1d4f3ed1344587$var$isMenuActive && $ce1d4f3ed1344587$var$running && e.target === document.getElementById('screen')) $ce1d4f3ed1344587$var$showGameMenu();
}
function $ce1d4f3ed1344587$var$handleScreenTapTouch(e) {
    if (!$ce1d4f3ed1344587$var$isMenuActive && $ce1d4f3ed1344587$var$running && e.changedTouches.length === 1) {
        const touch = e.changedTouches[0];
        if (document.elementFromPoint(touch.clientX, touch.clientY) === document.getElementById('screen')) $ce1d4f3ed1344587$var$showGameMenu();
    }
}
function $ce1d4f3ed1344587$var$showGameMenu() {
    $ce1d4f3ed1344587$var$overlay.classList.remove('hidden');
    if ($ce1d4f3ed1344587$var$backToMenuBtn) $ce1d4f3ed1344587$var$backToMenuBtn.classList.add('hidden');
    $ce1d4f3ed1344587$var$isMenuActive = true;
    $ce1d4f3ed1344587$var$selectedGameIndex = 0;
    $ce1d4f3ed1344587$var$setupGameLibraryNavigation();
    $762562ac9bfcda93$export$eaeea53739669088();
}
function $ce1d4f3ed1344587$var$hideGameMenu() {
    $ce1d4f3ed1344587$var$overlay.classList.add('hidden');
    if ($ce1d4f3ed1344587$var$backToMenuBtn) $ce1d4f3ed1344587$var$backToMenuBtn.classList.remove('hidden');
    $ce1d4f3ed1344587$var$isMenuActive = false;
}
function $ce1d4f3ed1344587$var$loadROMFromFile(file) {
    if (!file) return;
    $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Loading...';
    $ce1d4f3ed1344587$var$hideGameMenu();
    const reader = new FileReader();
    reader.onload = ()=>{
        if ($ce1d4f3ed1344587$var$useOffscreenCanvas) $ce1d4f3ed1344587$var$loadROMOffscreen(reader.result);
        else if ($ce1d4f3ed1344587$var$useWorkerMode) $ce1d4f3ed1344587$var$loadROMWorker(reader.result);
        else $ce1d4f3ed1344587$var$loadROMFallback(reader.result);
    };
    reader.onerror = ()=>{
        $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Read error';
        $ce1d4f3ed1344587$var$showGameMenu();
    };
    reader.readAsArrayBuffer(file);
}
async function $ce1d4f3ed1344587$var$loadROMFromURL(url, gameName) {
    $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Loading...';
    $ce1d4f3ed1344587$var$hideGameMenu();
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Failed to fetch ROM: ${response.status}`);
        const arrayBuffer = await response.arrayBuffer();
        if ($ce1d4f3ed1344587$var$useOffscreenCanvas) $ce1d4f3ed1344587$var$loadROMOffscreen(arrayBuffer);
        else if ($ce1d4f3ed1344587$var$useWorkerMode) $ce1d4f3ed1344587$var$loadROMWorker(arrayBuffer);
        else $ce1d4f3ed1344587$var$loadROMFallback(arrayBuffer);
    } catch  {
        $ce1d4f3ed1344587$var$statusDisplay.textContent = 'Load failed';
        $ce1d4f3ed1344587$var$showGameMenu();
    }
}
async function $ce1d4f3ed1344587$var$loadGameList() {
    const gameListEl = document.getElementById('game-list');
    try {
        gameListEl.innerHTML = '';
        (0, (/*@__PURE__*/$parcel$interopDefault($3e4c8d654368a5f8$exports))).forEach((game)=>{
            const button = document.createElement('button');
            button.className = 'game-item';
            button.dataset.rom = game.file;
            button.innerHTML = `
				<span class="game-name">${game.name}</span>
				<span class="game-genre">${game.genre}</span>
			`;
            gameListEl.appendChild(button);
        });
        const uploadBtn = document.createElement('button');
        uploadBtn.className = 'game-item game-item-upload';
        uploadBtn.dataset.action = 'upload';
        uploadBtn.innerHTML = `
			<span class="game-name">Load your own ROM</span>
			<span class="game-genre">Browse files...</span>
		`;
        gameListEl.appendChild(uploadBtn);
        // Setup event listeners once when game list is created
        $ce1d4f3ed1344587$var$setupGameItemListeners();
        $ce1d4f3ed1344587$var$setupGameLibraryNavigation();
    } catch  {
        gameListEl.innerHTML = '<div class="game-list-error">Failed to load games</div>';
    }
}
function $ce1d4f3ed1344587$var$setupGameItemListeners() {
    const items = document.querySelectorAll('.game-item');
    items.forEach((item)=>{
        item.addEventListener('click', (e)=>{
            e.preventDefault();
            e.stopPropagation();
        });
        item.addEventListener('touchstart', (e)=>{
            e.preventDefault();
            e.stopPropagation();
        }, {
            passive: false
        });
    });
}
function $ce1d4f3ed1344587$var$setupGameLibraryNavigation() {
    $ce1d4f3ed1344587$var$gameItems = Array.from(document.querySelectorAll('.game-item'));
    if ($ce1d4f3ed1344587$var$gameItems.length > 0) $ce1d4f3ed1344587$var$updateGameSelection(0);
}
function $ce1d4f3ed1344587$var$updateGameSelection(newIndex) {
    if ($ce1d4f3ed1344587$var$gameItems[$ce1d4f3ed1344587$var$selectedGameIndex]) $ce1d4f3ed1344587$var$gameItems[$ce1d4f3ed1344587$var$selectedGameIndex].classList.remove('selected');
    $ce1d4f3ed1344587$var$selectedGameIndex = Math.max(0, Math.min(newIndex, $ce1d4f3ed1344587$var$gameItems.length - 1));
    if ($ce1d4f3ed1344587$var$gameItems[$ce1d4f3ed1344587$var$selectedGameIndex]) {
        $ce1d4f3ed1344587$var$gameItems[$ce1d4f3ed1344587$var$selectedGameIndex].classList.add('selected');
        $ce1d4f3ed1344587$var$gameItems[$ce1d4f3ed1344587$var$selectedGameIndex].scrollIntoView({
            block: 'nearest',
            behavior: 'smooth'
        });
    }
}
function $ce1d4f3ed1344587$var$menuNavigateUp() {
    if (!$ce1d4f3ed1344587$var$isMenuActive || $ce1d4f3ed1344587$var$gameItems.length === 0) return;
    if ($ce1d4f3ed1344587$var$selectedGameIndex > 0) {
        $762562ac9bfcda93$export$eaeea53739669088();
        $ce1d4f3ed1344587$var$updateGameSelection($ce1d4f3ed1344587$var$selectedGameIndex - 1);
    }
}
function $ce1d4f3ed1344587$var$menuNavigateDown() {
    if (!$ce1d4f3ed1344587$var$isMenuActive || $ce1d4f3ed1344587$var$gameItems.length === 0) return;
    if ($ce1d4f3ed1344587$var$selectedGameIndex < $ce1d4f3ed1344587$var$gameItems.length - 1) {
        $762562ac9bfcda93$export$eaeea53739669088();
        $ce1d4f3ed1344587$var$updateGameSelection($ce1d4f3ed1344587$var$selectedGameIndex + 1);
    }
}
function $ce1d4f3ed1344587$var$confirmGameSelection() {
    if (!$ce1d4f3ed1344587$var$isMenuActive || $ce1d4f3ed1344587$var$gameItems.length === 0) return;
    const selectedItem = $ce1d4f3ed1344587$var$gameItems[$ce1d4f3ed1344587$var$selectedGameIndex];
    if (selectedItem) {
        $762562ac9bfcda93$export$19b9b4c652d89687();
        if (selectedItem.dataset.action === 'upload') {
            $ce1d4f3ed1344587$var$romInput.click();
            return;
        }
        const romFile = selectedItem.dataset.rom;
        const gameName = selectedItem.querySelector('.game-name').textContent;
        $ce1d4f3ed1344587$var$loadROMFromURL($ce1d4f3ed1344587$var$getRomUrl(romFile), gameName);
    }
}
function $ce1d4f3ed1344587$var$handleMenuInput(action) {
    if (!$ce1d4f3ed1344587$var$isMenuActive) return true;
    switch(action){
        case 'up':
            $ce1d4f3ed1344587$var$menuNavigateUp();
            return false;
        case 'down':
            $ce1d4f3ed1344587$var$menuNavigateDown();
            return false;
        case 'a':
        case 'start':
            $ce1d4f3ed1344587$var$confirmGameSelection();
            return false;
        default:
            return true;
    }
}
function $ce1d4f3ed1344587$var$handleScreenButtonDown(btnName) {
    // When menu is active, handle menu input and don't send to emulator
    if ($ce1d4f3ed1344587$var$isMenuActive) {
        $ce1d4f3ed1344587$var$handleMenuInput(btnName);
        return;
    }
    if ($ce1d4f3ed1344587$var$useOffscreenCanvas || $ce1d4f3ed1344587$var$useWorkerMode) {
        const bit = $ce1d4f3ed1344587$var$screenButtonMap[btnName];
        if (bit !== undefined) {
            $ce1d4f3ed1344587$var$buttonState |= 1 << bit;
            if ($ce1d4f3ed1344587$var$sharedControl) Atomics.store($ce1d4f3ed1344587$var$sharedControl, $ce1d4f3ed1344587$var$CTRL_BUTTONS, $ce1d4f3ed1344587$var$buttonState);
        }
    } else if ($ce1d4f3ed1344587$var$emu) {
        const button = $ce1d4f3ed1344587$var$screenButtonMapFallback[btnName];
        if (button) $ce1d4f3ed1344587$var$emu.setButton($ce1d4f3ed1344587$var$emu[button], true);
    }
}
function $ce1d4f3ed1344587$var$handleScreenButtonUp(btnName) {
    // Don't update button state when menu is active
    if ($ce1d4f3ed1344587$var$isMenuActive) return;
    if ($ce1d4f3ed1344587$var$useOffscreenCanvas || $ce1d4f3ed1344587$var$useWorkerMode) {
        const bit = $ce1d4f3ed1344587$var$screenButtonMap[btnName];
        if (bit !== undefined) {
            $ce1d4f3ed1344587$var$buttonState &= ~(1 << bit);
            if ($ce1d4f3ed1344587$var$sharedControl) Atomics.store($ce1d4f3ed1344587$var$sharedControl, $ce1d4f3ed1344587$var$CTRL_BUTTONS, $ce1d4f3ed1344587$var$buttonState);
        }
    } else if ($ce1d4f3ed1344587$var$emu) {
        const button = $ce1d4f3ed1344587$var$screenButtonMapFallback[btnName];
        if (button) $ce1d4f3ed1344587$var$emu.setButton($ce1d4f3ed1344587$var$emu[button], false);
    }
}
function $ce1d4f3ed1344587$var$setupScreenButtons() {
    const buttons = document.querySelectorAll('[data-btn]');
    buttons.forEach((btn)=>{
        const btnName = btn.dataset.btn;
        btn.addEventListener('mousedown', (e)=>{
            e.preventDefault();
            btn.classList.add('pressed');
            $ce1d4f3ed1344587$var$handleScreenButtonDown(btnName);
        });
        btn.addEventListener('mouseup', (e)=>{
            e.preventDefault();
            btn.classList.remove('pressed');
            $ce1d4f3ed1344587$var$handleScreenButtonUp(btnName);
        });
        btn.addEventListener('mouseleave', ()=>{
            btn.classList.remove('pressed');
            $ce1d4f3ed1344587$var$handleScreenButtonUp(btnName);
        });
        btn.addEventListener('touchstart', (e)=>{
            e.preventDefault();
            btn.classList.add('pressed');
            $ce1d4f3ed1344587$var$handleScreenButtonDown(btnName);
        }, {
            passive: false
        });
        btn.addEventListener('touchend', (e)=>{
            e.preventDefault();
            btn.classList.remove('pressed');
            $ce1d4f3ed1344587$var$handleScreenButtonUp(btnName);
        }, {
            passive: false
        });
        btn.addEventListener('touchcancel', ()=>{
            btn.classList.remove('pressed');
            $ce1d4f3ed1344587$var$handleScreenButtonUp(btnName);
        });
    });
}
document.addEventListener('DOMContentLoaded', ()=>{
    $ce1d4f3ed1344587$var$fpsDisplay = document.getElementById('fps');
    $ce1d4f3ed1344587$var$statusDisplay = document.getElementById('status');
    $ce1d4f3ed1344587$var$overlay = document.getElementById('overlay');
    $ce1d4f3ed1344587$var$loadBtn = document.getElementById('load-btn');
    $ce1d4f3ed1344587$var$resetBtn = document.getElementById('reset-btn');
    $ce1d4f3ed1344587$var$fullscreenBtn = document.getElementById('fullscreen-btn');
    $ce1d4f3ed1344587$var$shaderBtn = document.getElementById('shader-btn');
    $ce1d4f3ed1344587$var$romInput = document.getElementById('rom-input');
    $ce1d4f3ed1344587$var$powerLed = document.getElementById('power-led');
    $ce1d4f3ed1344587$var$speaker = document.getElementById('speaker');
    $ce1d4f3ed1344587$var$gameboy = document.querySelector('.gameboy');
    $ce1d4f3ed1344587$var$backToMenuBtn = document.getElementById('back-to-menu');
    $762562ac9bfcda93$export$9aae99d5b562ef5c($ce1d4f3ed1344587$var$speaker);
    const hasSAB = $ce1d4f3ed1344587$var$isSharedArrayBufferAvailable();
    const hasOffscreen = $ce1d4f3ed1344587$var$isOffscreenCanvasAvailable();
    const forceDebug = new URLSearchParams(window.location.search).has('debug');
    if (forceDebug) {
        $ce1d4f3ed1344587$var$useOffscreenCanvas = false;
        $ce1d4f3ed1344587$var$useWorkerMode = false;
    } else if (hasSAB && hasOffscreen) {
        $ce1d4f3ed1344587$var$useOffscreenCanvas = true;
        $ce1d4f3ed1344587$var$useWorkerMode = true;
    } else if (hasSAB) {
        $ce1d4f3ed1344587$var$useOffscreenCanvas = false;
        $ce1d4f3ed1344587$var$useWorkerMode = true;
    } else {
        $ce1d4f3ed1344587$var$useOffscreenCanvas = false;
        $ce1d4f3ed1344587$var$useWorkerMode = false;
    }
    const savedShader = localStorage.getItem('gbemu-shader');
    if (savedShader !== null) {
        $ce1d4f3ed1344587$var$currentShader = parseInt(savedShader, 10);
        if (isNaN($ce1d4f3ed1344587$var$currentShader) || $ce1d4f3ed1344587$var$currentShader < 0 || $ce1d4f3ed1344587$var$currentShader >= (0, $faeb2bdca75fd65c$export$5980fef2a1c75115)) $ce1d4f3ed1344587$var$currentShader = (0, $faeb2bdca75fd65c$export$b264eab3e2508b6);
    }
    if ($ce1d4f3ed1344587$var$shaderBtn) $ce1d4f3ed1344587$var$shaderBtn.title = `Shader: ${(0, $faeb2bdca75fd65c$export$53341c93aaf417f1)[$ce1d4f3ed1344587$var$currentShader]}`;
    if (!$ce1d4f3ed1344587$var$useOffscreenCanvas) {
        if (!$ce1d4f3ed1344587$var$initWebGL()) $ce1d4f3ed1344587$var$initCanvas2D();
    }
    $ce1d4f3ed1344587$var$loadBtn.addEventListener('click', ()=>$ce1d4f3ed1344587$var$romInput.click());
    $ce1d4f3ed1344587$var$romInput.addEventListener('change', $ce1d4f3ed1344587$var$handleFileSelect);
    $ce1d4f3ed1344587$var$fullscreenBtn.addEventListener('click', $ce1d4f3ed1344587$var$toggleFullscreen);
    $ce1d4f3ed1344587$var$shaderBtn.addEventListener('click', ()=>$ce1d4f3ed1344587$var$showShaderNotification($ce1d4f3ed1344587$var$cycleShader()));
    $ce1d4f3ed1344587$var$speaker.addEventListener('click', $762562ac9bfcda93$export$8ed30069de84a7d6);
    $ce1d4f3ed1344587$var$backToMenuBtn.addEventListener('click', $ce1d4f3ed1344587$var$showGameMenu);
    $ce1d4f3ed1344587$var$loadGameList();
    $ce1d4f3ed1344587$var$setupScreenButtons();
    const screenInner = document.querySelector('.gb-screen-inner');
    screenInner.addEventListener('dragover', $ce1d4f3ed1344587$var$handleDragOver);
    screenInner.addEventListener('dragleave', $ce1d4f3ed1344587$var$handleDragLeave);
    screenInner.addEventListener('drop', $ce1d4f3ed1344587$var$handleDrop);
    screenInner.addEventListener('click', $ce1d4f3ed1344587$var$handleScreenTap);
    screenInner.addEventListener('touchend', $ce1d4f3ed1344587$var$handleScreenTapTouch, {
        passive: true
    });
    if ($ce1d4f3ed1344587$var$useOffscreenCanvas) {
        $ce1d4f3ed1344587$var$initSharedMemoryOffscreen();
        $ce1d4f3ed1344587$var$initWorkerOffscreen();
        $ce1d4f3ed1344587$var$resetBtn.addEventListener('click', $ce1d4f3ed1344587$var$resetEmulationOffscreen);
        document.addEventListener('keydown', $ce1d4f3ed1344587$var$handleKeyDownOffscreen);
        document.addEventListener('keyup', $ce1d4f3ed1344587$var$handleKeyUpOffscreen);
    } else if ($ce1d4f3ed1344587$var$useWorkerMode) {
        $ce1d4f3ed1344587$var$initSharedMemory();
        $ce1d4f3ed1344587$var$initWorker();
        $ce1d4f3ed1344587$var$resetBtn.addEventListener('click', $ce1d4f3ed1344587$var$resetEmulationWorker);
        document.addEventListener('keydown', $ce1d4f3ed1344587$var$handleKeyDownWorker);
        document.addEventListener('keyup', $ce1d4f3ed1344587$var$handleKeyUpWorker);
    } else {
        if (typeof createGBEmu === 'undefined') {
            $ce1d4f3ed1344587$var$statusDisplay.textContent = 'WASM not found';
            return;
        }
        $ce1d4f3ed1344587$var$initEmulatorFallback();
        $ce1d4f3ed1344587$var$resetBtn.addEventListener('click', $ce1d4f3ed1344587$var$resetEmulationFallback);
        document.addEventListener('keydown', $ce1d4f3ed1344587$var$handleKeyDownFallback);
        document.addEventListener('keyup', $ce1d4f3ed1344587$var$handleKeyUpFallback);
    }
});
window.getMode = ()=>{
    if ($ce1d4f3ed1344587$var$useOffscreenCanvas) return 'OffscreenCanvas mode';
    if ($ce1d4f3ed1344587$var$useWorkerMode) return 'Worker mode';
    return 'Fallback mode';
};
window.debug = ()=>{
    if (!$ce1d4f3ed1344587$var$emu) return {
        error: 'Emulator not initialized'
    };
    return {
        cpu: $ce1d4f3ed1344587$var$emu.getCPUState(),
        ppu: $ce1d4f3ed1344587$var$emu.getPPUState(),
        mbc: $ce1d4f3ed1344587$var$emu.getMBCState(),
        vram: $ce1d4f3ed1344587$var$emu.checkVRAM(),
        framebuffer: $ce1d4f3ed1344587$var$emu.getFramebufferStats()
    };
};
window.readMem = (addr, count = 16)=>{
    if (!$ce1d4f3ed1344587$var$emu) return null;
    return Array.from($ce1d4f3ed1344587$var$emu.readMemory(addr, count));
};
window.tracePC = (frames = 10)=>{
    if (!$ce1d4f3ed1344587$var$emu) return null;
    let pcs = [];
    for(let i = 0; i < frames; i++){
        pcs.push($ce1d4f3ed1344587$var$emu.getCPUState().pc.toString(16));
        $ce1d4f3ed1344587$var$emu.runFrame();
    }
    return pcs;
};
window.toggleAudio = ()=>{
    $762562ac9bfcda93$export$8ed30069de84a7d6();
    return $762562ac9bfcda93$export$81b32540e2005e6();
};
window.audioStatus = ()=>{
    const status = $762562ac9bfcda93$export$bbf5b9923049cd28();
};
window.getCapabilities = ()=>({
        SharedArrayBuffer: $ce1d4f3ed1344587$var$isSharedArrayBufferAvailable(),
        OffscreenCanvas: $ce1d4f3ed1344587$var$isOffscreenCanvasAvailable(),
        AudioWorklet: !!(window.AudioContext && AudioContext.prototype.audioWorklet),
        WebGL: !!document.createElement('canvas').getContext('webgl')
    });


//# sourceMappingURL=web.4851a97c.js.map
